module.exports = __webpack_public_path__ + "img/logo.7589d003.png";